export default __webpack_public_path__ + "static/media/surrounding_operators.0c234ee2.png";